import type { IconNode } from '../types';

/**
 * @name file-box
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMnY1YTEgMSAwIDAwMSAxaDUiIC8+CiAgPHBhdGggZD0iTTE0LjY5MiAyMkgxOGEyIDIgMCAwMDItMlY4YTIuNCAyLjQgMCAwMC0uNzA2LTEuNzA2bC0zLjU4OC0zLjU4OEEyLjQgMi40IDAgMDAxNCAySDZhMiAyIDAgMDAtMiAydjMuODA0IiAvPgogIDxwYXRoIGQ9Ik0yLjI2NCAxMy43NTIgNyAxNi41bDQuNzM3LTIuNzQ4IiAvPgogIDxwYXRoIGQ9Ik0yLjk5NSAxMy4wMTRBMiAyIDAgMDAyIDE0Ljc0NHYzLjUxNmEyIDIgMCAwMC45OTYgMS43M2wzIDEuNzRhMiAyIDAgMDAyLjAwOCAwbDMtMS43NEEyIDIgMCAwMDEyIDE4LjI2di0zLjUxN2EyIDIgMCAwMC0uOTk1LTEuNzNsLTMtMS43NDJhMiAyIDAgMDAtMS44OTItLjA2NHoiIC8+CiAgPHBhdGggZD0iTTcgMTYuNVYyMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/file-box
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const FileBox: IconNode = [
  ['path', { d: 'M14 2v5a1 1 0 001 1h5' }],
  [
    'path',
    {
      d: 'M14.692 22H18a2 2 0 002-2V8a2.4 2.4 0 00-.706-1.706l-3.588-3.588A2.4 2.4 0 0014 2H6a2 2 0 00-2 2v3.804',
    },
  ],
  ['path', { d: 'M2.264 13.752 7 16.5l4.737-2.748' }],
  [
    'path',
    {
      d: 'M2.995 13.014A2 2 0 002 14.744v3.516a2 2 0 00.996 1.73l3 1.74a2 2 0 002.008 0l3-1.74A2 2 0 0012 18.26v-3.517a2 2 0 00-.995-1.73l-3-1.742a2 2 0 00-1.892-.064z',
    },
  ],
  ['path', { d: 'M7 16.5V22' }],
];

export default FileBox;
